import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    FRONTEND: "Frontend",
    FULLSTACK: "Fullstack",
  };

  const projectsData = [
    {
      title: "Evangadi Forum App",
      thumbImage: "images/projects/project-1.jpg",
      categories: [filters.FULLSTACK],
      sourceCode: "https://github.com/Mekonnen46/Evangadi-forum-app",
      demo: "https://mekforumapp.netlify.app/",
    },
    {
      title: "E-Commerce Website (Amazon Clone)",
      thumbImage: "images/projects/project-2.jpg",
      categories: [filters.FULLSTACK],
      sourceCode: "https://github.com/Mekonnen46/amazon-clone",
      demo: "https://amaazon-clone-project.netlify.app/",
    },
    {
      title: "Netflix Clone",
      thumbImage: "images/projects/project-3.jpg",
      categories: [filters.FRONTEND],
      sourceCode: "https://github.com/Mekonnen46/Netflix-clone-2025",
      demo: "https://netfllix-clone-project.netlify.app/",
    },
    {
      title: "Apple Clone (React)",
      thumbImage: "images/projects/project-4.jpg",
      categories: [filters.FRONTEND],
      sourceCode: "https://github.com/Mekonnen46/apple-react-clone",
      demo: "https://splendorous-chaja-e292e9.netlify.app/",
    },
  ];

  console.log(projectsData.length);

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, [isRtl]);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section"}>
        <div className={"container"}>
          {/* Heading */}
          <div className="row mb-5 wow fadeInUp">
            <div className="col-lg-9 col-xl-8 mx-auto text-center">
              <h2 className="fw-600 mb-3"> Practical Projects </h2>
              <hr className="heading-separator-line border-primary border-2 opacity-10 mx-auto" />
              {/* <p className="text-4 text-muted"></p> */}
            </div>
          </div>

          {/* Heading end*/}
          {/* Filter Menu */}
          <ul className="portfolio-menu nav nav-pills text-uppercase justify-content-center border-bottom-0 mb-5 wow fadeInUp">
            <li className="nav-item">
              <button
                className={
                  "nav-link rounded-pill " + (filterKey === "*" ? "active" : "")
                }
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link rounded-pill " +
                    (filterKey === oneKey ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-md-6  filter-item " +
                      getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <div className=" d-flex flex-column align-items-center justify-content-center h-100 w-100">
                            <h5 className="text-white fw-400 mb-3">
                              {project?.title}
                            </h5>
                            <div className="portfolio-btn-group d-flex justify-content-center gap-2">
                              {project.sourceCode && (
                                <a
                                  href={project.sourceCode}
                                  className="btn btn-sm btn-portfolio-action"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <i className="fab fa-github me-1"></i> Source
                                  Code
                                </a>
                              )}
                              {project.demo && (
                                <a
                                  href={project.demo}
                                  className="btn btn-sm btn-portfolio-action"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <i className="fas fa-external-link-alt me-1"></i>{" "}
                                  View Demo
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
